getTypePolicy